import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import Button from '../../../Button';
import palette from '../../../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  button: {
    marginRight: typography.pxToRem(20),
  },
}));

const DriverButtons = ({
  onDefer,
  onReject,
  onAccept,
  isDisabledAccept,
  isDisabledDefer = false,
}) => {
  const classes = useStyles();

  return (
    <>
      <Button
        data-testid="defer"
        variant="contained"
        disabled={isDisabledDefer}
        bgColor={palette.modalButtons.yellow}
        color={palette.typography.black.solid}
        className={classes.button}
        border="1px solid #E3AD1A"
        onClick={onDefer}
        opacityDisabled={0.38}
      >
        Defer
      </Button>
      <Button
        data-testid="reject"
        variant="contained"
        disabled={false}
        bgColor={palette.modalButtons.orange}
        className={classes.button}
        border="1px solid #F25041"
        onClick={onReject}
      >
        Reject
      </Button>
      <Button
        data-testid="accept"
        variant="contained"
        disabled={isDisabledAccept}
        bgColor={palette.modalButtons.blue}
        border="1px solid #0060A2"
        onClick={onAccept}
        opacityDisabled={0.38}
      >
        Accept
      </Button>
    </>
  );
};

export default memo(DriverButtons);
